import React from 'react';
import PropTypes from 'prop-types';
import { Chip, Typography } from '@mui/material';

/**
 * The one prize somebody won — the highest rung they cleared — or a dash.
 *
 * Prizes do not add up, so wherever a challenge's result is shown there is at
 * most one of these per person (or per round, on a challenge judged round by
 * round). Shared so the board, the round grid and the group view all read the
 * same.
 */
export default function PrizeWonChip({ prize, empty = '—' }) {
  if (!prize) {
    return (
      <Typography variant="body2" color="text.disabled">
        {empty}
      </Typography>
    );
  }
  return <Chip size="small" color="success" label={prize} sx={{ maxWidth: 220 }} />;
}

PrizeWonChip.propTypes = {
  /** The prize's name, or nothing when no rung was cleared. */
  prize: PropTypes.string,
  /** What to show when there is no prize. */
  empty: PropTypes.node,
};
